import React, { ComponentProps } from 'react';

import SideNavigation from '@adsk/alloy-side-navigation';
import {
  RemoteComponent,
  RemoteComponentProps,
} from '@adsk/exo-skeleton-react';

import RemoteSideNavigationError from './RemoteSideNavigationError';
import RemoteSideNavigationLoader from './RemoteSideNavigationLoader';

type RemoteSideNavigationProps = Omit<
  RemoteComponentProps<ComponentProps<typeof SideNavigation>>,
  'renderLoader' | 'renderError'
>;

const RemoteSideNavigation = ({ ...props }: RemoteSideNavigationProps) => (
  <RemoteComponent<ComponentProps<typeof SideNavigation>>
    renderLoader={() => <RemoteSideNavigationLoader />}
    renderError={() => <RemoteSideNavigationError />}
    {...props}
  />
);

export default RemoteSideNavigation;
